var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { ExperimentStepStates, ConfigProviderMigrationState, ExperimentStates } from "@ane/exp-data/lib/models";
import { getAggregatedState } from "@ane/exp-data/lib/utils/ExperimentStateUtils";
import ___default from "lodash";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
class ProgressionUtils {
  getActiveProgressionReferences(progressionsDtos) {
    let activeProgressionReferences = {};
    ___default.forEach(progressionsDtos, (value) => {
      const { IsArchived, ClonedFromId, Id } = value;
      if (!IsArchived && !!ClonedFromId) {
        activeProgressionReferences[ClonedFromId] = Id;
      }
    });
    return activeProgressionReferences;
  }
  getUnclonedProgressions(progressionsDtos) {
    const activeProgressionReferences = this.getActiveProgressionReferences(progressionsDtos);
    let unclonedProgressions = {};
    ___default.forEach(progressionsDtos, (value) => {
      const { Id, IsArchived } = value;
      unclonedProgressions[Id] = !IsArchived && !!!activeProgressionReferences[Id];
    });
    return unclonedProgressions;
  }
  getAllProgressionStages(progressionDto) {
    var _a;
    return ((_a = progressionDto.Studies) != null ? _a : []).sort(
      (t1, t2) => {
        var _a2, _b, _c, _d;
        return ((_b = (_a2 = t1.ExperimentTrialConfiguration) == null ? void 0 : _a2.SequenceIndex) != null ? _b : -1) - ((_d = (_c = t2.ExperimentTrialConfiguration) == null ? void 0 : _c.SequenceIndex) != null ? _d : -1);
      }
    );
  }
  getFilteredProgressionStages(progressionDto) {
    const sortedStages = this.getAllProgressionStages(progressionDto);
    return ___default.filter(sortedStages, (value, index, collection) => {
      const restartedProgStages = ___default.filter(collection, (gs) => gs.RestartedFromId === value.Id);
      const hiddenRestartedProgStages = ___default.filter(collection, (gs) => gs.IsHidden);
      const showStage = hiddenRestartedProgStages.length && hiddenRestartedProgStages.length === restartedProgStages.length;
      return !value.IsHidden && (!restartedProgStages.length || showStage);
    });
  }
  isProgressionStageNotRunning(progressionStageDto) {
    return ___default.every(progressionStageDto.Stages, (value) => ExperimentStepStates.stepNotRunning(value.State));
  }
  isProgressionNotRunning(progressionDto) {
    const allProgressionStages = this.getAllProgressionStages(progressionDto);
    return ___default.every(allProgressionStages, (stg) => this.isProgressionStageNotRunning(stg));
  }
  getProgressionsToLoad(progressionDtos) {
    const unclonedProgressions = this.getUnclonedProgressions(progressionDtos);
    let progressionsToLoad = {};
    ___default.forEach(progressionDtos, (value) => {
      const { Id } = value;
      progressionsToLoad[Id] = !!unclonedProgressions[Id] || !this.isProgressionNotRunning(value);
    });
    return progressionsToLoad;
  }
  getAggregatedProgressionStageState(progressionStageDto, configProviderMigrationState) {
    return getAggregatedState(
      !!configProviderMigrationState && configProviderMigrationState !== ConfigProviderMigrationState.new && configProviderMigrationState !== ConfigProviderMigrationState.migrationFailed ? [configProviderMigrationState.toString()] : progressionStageDto.Stages.map((s) => s.State)
    );
  }
  getAggregatedProgressionState(progressionDto) {
    const filteredProgressionStages = this.getFilteredProgressionStages(progressionDto);
    const states = ___default.map(
      filteredProgressionStages,
      (t) => {
        var _a;
        return this.getAggregatedProgressionStageState(t, (_a = progressionDto == null ? void 0 : progressionDto.ConfigProviderInfo) == null ? void 0 : _a.LatestConfigProviderMigrationState).State;
      }
    );
    return getAggregatedState(states);
  }
  getEnabledProgressionStages(progressionDto, mdsProgressionTemplates) {
    const filteredProgressionStages = this.getFilteredProgressionStages(progressionDto);
    let enabledStages = {};
    const { FrontierStageIndex: ProgressionFrontierIndex } = this.getAggregatedProgressionState(progressionDto);
    ___default.forEach(filteredProgressionStages, (progressionStage, index, collection) => {
      var _a, _b, _c, _d;
      const prevProgressionStage = index > 0 ? collection[index - 1] : null;
      const stages = (_a = prevProgressionStage == null ? void 0 : prevProgressionStage.Stages) != null ? _a : [];
      const lastStageInPrevProgressionStage = stages == null ? void 0 : stages[stages.length - 1];
      const { FrontierStageIndex: ProgressionStageFrontierIndex } = this.getAggregatedProgressionStageState(
        progressionStage,
        (_b = progressionDto == null ? void 0 : progressionDto.ConfigProviderInfo) == null ? void 0 : _b.LatestConfigProviderMigrationState
      );
      const lessThanFrontierStageIndex = index <= ProgressionFrontierIndex;
      const prevProgStageInLastStep = !!prevProgressionStage && ((_c = lastStageInPrevProgressionStage == null ? void 0 : lastStageInPrevProgressionStage.State) == null ? void 0 : _c.toLowerCase()) !== ExperimentStates.NEW;
      const unlockWithPrevStage = prevProgressionStage && !!((_d = mdsProgressionTemplates == null ? void 0 : mdsProgressionTemplates[progressionDto.TrialTemplateId]) == null ? void 0 : _d.DefaultUnlockWithPrevious) && enabledStages[prevProgressionStage.Id];
      const stageAlreadyStarted = (EnvironmentService.enableNoStepsInStageFix() ? progressionStage.Stages[ProgressionStageFrontierIndex] : true) && progressionStage.Stages[ProgressionStageFrontierIndex].State.toLowerCase() !== ExperimentStates.NEW;
      enabledStages[progressionStage.Id] = index === 0 || lessThanFrontierStageIndex || prevProgStageInLastStep || unlockWithPrevStage || stageAlreadyStarted;
    });
    return enabledStages;
  }
  getProgressionDtos(input) {
    const { progressionStages, progressions, resultProgressionIds } = input;
    return ___default.map(resultProgressionIds, (progressionId) => {
      var _a;
      return __spreadProps(__spreadValues({}, progressions[progressionId]), {
        Studies: ___default.map((_a = progressions[progressionId]) == null ? void 0 : _a.Studies, (stageId) => progressionStages[stageId])
      });
    });
  }
  getMdsProgressionTemplates(progressionTemplatesBySnapshot, mdsSnapshot, defaultVal) {
    if (!mdsSnapshot || !progressionTemplatesBySnapshot) {
      return defaultVal;
    }
    return !!progressionTemplatesBySnapshot[mdsSnapshot] ? progressionTemplatesBySnapshot[mdsSnapshot].ProgressionTemplates : defaultVal;
  }
  latestFlightAllocationId(progressionStageDto, flightName, configProviderMigrationState) {
    var _a, _b;
    let latestFlightAllocationId = NaN;
    if (this.getAggregatedProgressionStageState(progressionStageDto, configProviderMigrationState).State === ExperimentStates.RUNNING) {
      const lastStageWithFlightAllocation = ___default.findLast(progressionStageDto.Stages, (stage) => {
        var _a2, _b2, _c, _d;
        return !!((_b2 = (_a2 = stage == null ? void 0 : stage.ParallelSteps) == null ? void 0 : _a2[0]) == null ? void 0 : _b2.FlightAllocationIdsMap) && !!((_d = (_c = stage == null ? void 0 : stage.ParallelSteps) == null ? void 0 : _c[0]) == null ? void 0 : _d.FlightAllocationIdsMap[flightName]);
      });
      if (!!lastStageWithFlightAllocation) {
        latestFlightAllocationId = (_b = (_a = lastStageWithFlightAllocation == null ? void 0 : lastStageWithFlightAllocation.ParallelSteps) == null ? void 0 : _a[0]) == null ? void 0 : _b.FlightAllocationIdsMap[flightName];
      }
    }
    return latestFlightAllocationId;
  }
}
const ProgressionsUtils = new ProgressionUtils();
export {
  ProgressionsUtils as default
};
//# sourceMappingURL=Progressions.utils.js.map
